import React from "react";
import { CardContent, CardHeader, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import PropTypes from "prop-types";

const Chart = ({ options, series, type, height, title }) => {
  return (
    <>
      <CardHeader
        title={
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
        }
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type={type}
          height={height}
        />
      </CardContent>
    </>
  );
};

Chart.propTypes = {
  options: PropTypes.object,
  series: PropTypes.array,
  type: PropTypes.string,
  height: PropTypes.number,
  title: PropTypes.string,
};

export default Chart;
